import * as THREE from "three";
// @ts-ignore
import { GLTFLoader } from "three/addons/loaders/GLTFLoader.js";
// @ts-ignore
import { RGBELoader } from "three/addons/loaders/RGBELoader.js";

let loadPromis: Promise<{ gltf: unknown; texture: unknown }> | undefined;
let loadPearlPromis: Promise<string> | undefined;
let loadsilverGPromis: Promise<string> | undefined;

export function load3dAnimation() {
  if (loadPromis) return loadPromis;
  loadPromis = new Promise((resolve) => {
    new RGBELoader()
      .setPath("/")
      .load("royal_esplanade_1k.hdr", function (texture: unknown) {
        const loader = new GLTFLoader().setPath("/");
        loader.load("serebroCA1.gltf", function (gltf: unknown) {
          (texture as THREE.Texture).mapping = THREE.EquirectangularReflectionMapping;
          void loadPearlVideo().then(() => loadSilverGVideo());
          resolve({ gltf, texture });
        });
      });
  });
  return loadPromis;
}

export function loadPearlVideo() {
  if (loadPearlPromis) return loadPearlPromis;
  loadPearlPromis = new Promise((resolve) => {
    fetch("/goldp.webm")
      .then((res) => res.blob())
      .then((blob) => resolve(URL.createObjectURL(blob)));
  });
  return loadPearlPromis;
}

export function loadSilverGVideo() {
  if (loadsilverGPromis) return loadsilverGPromis;
  loadsilverGPromis = new Promise((resolve) => {
    fetch("/silver_gold.webm")
      .then((res) => res.blob())
      .then((blob) => resolve(URL.createObjectURL(blob)));
  });
  return loadsilverGPromis;
}
